/**
 * owl.carousel doesn't initialize properly if it is hidden. As this is the
 * case inside accordions, we refresh owl.carousels on opening accordion items here.
 */

import $ from 'jquery';

import App from 'libs/app';

App.registerReadyHandler("zf.accordion-owl-integration", function () {
    $("[data-accordion]").filter(function () {
        // only accordion which include an owl carousel
        return $("[data-carousel]", this).length > 0;
    })
        .on("down.zf.accordion", function (event) {
            // refresh visible owl carousels in the accordion
            $("[data-carousel]:visible", event.currentTarget).trigger("refresh.owl.carousel");
        });
});
